// @flow

import { type OpenedIncomingPayment, type PreTokenizedCard } from './types';

export function getPreTokenizedCard(incomingPayment: OpenedIncomingPayment): ?PreTokenizedCard {
  return incomingPayment.pre_tokenized_card;
}

export function getSafePreTokenizedCard(incomingPayment: OpenedIncomingPayment): PreTokenizedCard {
  const preTokenizedCard = getPreTokenizedCard(incomingPayment);

  if (!preTokenizedCard) {
    throw new Error('Missing pre_tokenized_card');
  }

  return preTokenizedCard;
}
